import { useState, useEffect } from 'react';
import MuxVideoPlayer from '../../../../Pages/VideoPlayer/components/MuxVideoPlayer';
import { userInfoAtom } from '../../../../data/atoms/utilsAtoms';
import { PlayerPageWrapper } from '../../../../Pages/VideoPlayer/PlayerPage';
import api from '../../../../data/api';
import { useAtomValue } from 'jotai';
import { useParams } from 'react-router-dom';
import CommonContent from '../../../components/CommonContent';
import '../../../trc.css';
import Toast from '../../../../utils/toastManager';
import TRCVideoDescription from '../components/description';

const TRCVideo = () => {
	const userData = useAtomValue(userInfoAtom);
	const { id } = useParams();
	const [video, setVideo] = useState();

	const fetchContentDataById = async () => {
		try {
			const response = await api.getContentById(id);
			
			setVideo(response?.data);
		} catch (err) {
			Toast.error(err.message || "Something went wrong")
		}
	};
	useEffect(() => {
		fetchContentDataById();
	}, [id]);

	return (
		<div className="d-flex flex-column">
			<div className="video-container">
				<MuxVideoPlayer
					CustomWrapper={PlayerPageWrapper}
					videoLink={video?.fileUrl}
					videoTitle={video?.title}
					poster={video?.thumbnailLink}
					storyboardToken={video?.contentStoryboardToken}
					userId={userData?.user?._id}
					videoId={video?._id}
					videoCategory="TRC Video"
					userEmail={userData?.user?.email}
				/>
				<TRCVideoDescription selectedVideo={video} />
			</div>
			<CommonContent type={video?.fileType} content={video} />
		</div>
	);
};

export default TRCVideo;
